import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoRiskyEntities = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 226,
	height: 176,
	viewBox: "0 0 226 176",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-no-high-risk",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_17366",
				"data-name": "Rectangle 17366",
				width: 226,
				height: 176,
				transform: "translate(812 753)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-no-high-risk-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16882",
				"data-name": "Rectangle 16882",
				width: 79.739,
				height: 139.903,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-no-high-risk-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16884",
				"data-name": "Rectangle 16884",
				width: 67.046,
				height: 137.39,
				fill: "none"
			})
		})
	] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14591",
		"data-name": "Mask Group 14591",
		transform: "translate(-812 -753)",
		clipPath: "url(#clip-path-no-high-risk)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_15105",
			"data-name": "Group 15105",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_39781",
				"data-name": "Path 39781",
				d: "M89.438.037C117.924.8,146.785,13.191,154.3,42.117c3.7,14.224-1.156,29.314,3.473,43.349,4.681,14.192,19.534,18.341,29.71,27.839,12.286,11.469,15.957,31.353,7.76,46.075-8.846,15.888-30.233,23.825-47.618,17.671-15-5.311-25.159-18.859-38.445-27.505a65.85,65.85,0,0,0-39.3-10.415c-7.961.452-15.847,2.352-23.81,1.961C24.035,140.01,6.06,120.708,1.493,99.577S3.386,56.363,13.407,37.121c3.849-7.391,8.339-14.652,14.755-20.073C37.542,9.121,50.03,5.909,62.044,2.932A103.563,103.563,0,0,1,89.438.037Z",
				transform: "matrix(0.643, -0.766, 0.766, 0.643, 785.225, 854.93)",
				fill: "#7b8efa",
				opacity: .137
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_15104",
				"data-name": "Group 15104",
				transform: "translate(-6205.336 -2805.488)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_14230",
					"data-name": "Group 14230",
					transform: "translate(7051.399 3576.438)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_14229",
						"data-name": "Group 14229",
						transform: "translate(0 0)",
						clipPath: "url(#clip-path-no-high-risk-2)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39518",
								"data-name": "Path 39518",
								d: "M523.12,30.23c-.012,0-.009,0-.009-.006a.019.019,0,0,1,0-.011.156.156,0,0,1,.013-.024.5.5,0,0,1,.035-.049c.025-.033.053-.066.082-.1.057-.067.119-.128.18-.194.125-.126.254-.248.384-.369.262-.239.53-.464.8-.68.543-.431,1.1-.825,1.657-1.2s1.14-.71,1.687-1.091q.412-.283.806-.585t.771-.618a17.032,17.032,0,0,0,1.425-1.336,15.215,15.215,0,0,0,1.249-1.466,14.564,14.564,0,0,0,1.05-1.6l.116-.209.1-.209c.035-.067.07-.143.106-.219l.107-.227.211-.482c.069-.167.14-.329.208-.5.545-1.359,1.061-2.807,1.545-4.263q.37-1.092.714-2.2t.682-2.217c.223-.741.44-1.483.647-2.227s.411-1.488.606-2.23.375-1.485.54-2.221.311-1.468.419-2.157l.012-.075a1.741,1.741,0,0,1,3.456.152c.03.443.048.879.047,1.3,0,.213,0,.425,0,.633s-.006.419-.013.626c-.029.831-.081,1.65-.15,2.464-.138,1.627-.337,3.235-.575,4.836q-.181,1.2-.389,2.4t-.454,2.391c-.331,1.595-.687,3.183-1.159,4.814-.057.2-.123.411-.184.617s-.133.419-.2.628l-.111.323c-.037.107-.074.215-.118.329q-.128.337-.258.665a19.722,19.722,0,0,1-1.237,2.545,22.05,22.05,0,0,1-1.569,2.337,24.153,24.153,0,0,1-1.838,2.093,24.434,24.434,0,0,1-2.043,1.847,18.032,18.032,0,0,1-2.219,1.584,11.95,11.95,0,0,1-2.481,1.105,10.076,10.076,0,0,1-1.345.322c-.231.038-.466.068-.708.089-.122.008-.244.018-.371.022-.063,0-.128,0-.2.005l-.1,0h-.088a.244.244,0,0,0-.044.005,2.835,2.835,0,0,1-1.8-5.378",
								transform: "translate(-463.036 -0.003)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39519",
								"data-name": "Path 39519",
								d: "M510.192,1231.48c-.818-1-1.264-1.444-1.264-1.444l-1.822.641.407,1.479Z",
								transform: "translate(-450.529 -1094.828)",
								fill: "#ffa88d"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39520",
								"data-name": "Path 39520",
								d: "M285.215,1175.233a16.98,16.98,0,0,0-.689,2.52,12.089,12.089,0,0,0-.176,1.254,6.036,6.036,0,0,0,0,1.089l.015.136a1.533,1.533,0,0,1-3,.579,8.568,8.568,0,0,1-.289-1.791,15.275,15.275,0,0,1-.012-1.64,20.617,20.617,0,0,1,.389-3.172l0-.023a1.958,1.958,0,0,1,3.84.773,2.131,2.131,0,0,1-.077.276",
								transform: "translate(-249.688 -1043.81)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39521",
								"data-name": "Path 39521",
								d: "M498.911,1174.948a16.962,16.962,0,0,0-.455,2.573,12.118,12.118,0,0,0-.061,1.265,6.044,6.044,0,0,0,.1,1.084l.027.135a1.533,1.533,0,0,1-2.935.851,8.583,8.583,0,0,1-.452-1.757,15.3,15.3,0,0,1-.163-1.632,20.631,20.631,0,0,1,.1-3.195l0-.024a1.959,1.959,0,1,1,3.895.419,2.145,2.145,0,0,1-.051.281",
								transform: "translate(-439.726 -1043.709)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39522",
								"data-name": "Path 39522",
								d: "M389.979,141.847c-1.395,1.583-1.915,3.926-.483,4.818s7.159,2.169,8.256.694a3.387,3.387,0,0,0,0-4.376c-1.035-1.175-7.773-1.137-7.773-1.137",
								transform: "translate(-345.285 -126.022)",
								fill: "#7a020c"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39523",
								"data-name": "Path 39523",
								d: "M426.361,619.689c1.173,5.034,2.315,10.048,3.423,15.1.551,2.528,1.1,5.053,1.605,7.633.126.649.252,1.3.372,1.967l.09.506.087.52.085.552.021.144.021.161.041.322c.093.8.134,1.546.151,2.287s0,1.458-.028,2.166c-.061,1.415-.194,2.781-.359,4.126s-.365,2.663-.581,3.969c-.437,2.61-.942,5.167-1.482,7.694-.264,1.264-.545,2.519-.821,3.768l-.821,3.725q-.2.926-.387,1.845c-.126.613-.252,1.222-.365,1.828s-.219,1.207-.309,1.8c-.045.3-.087.592-.122.883-.01.073-.015.147-.03.218a.522.522,0,0,1-.114.213,1.105,1.105,0,0,1-.253.208,2.154,2.154,0,0,1-.454.208l-.324.11a4.269,4.269,0,0,1-3.178-.182,1.809,1.809,0,0,1-.421-.272,1.136,1.136,0,0,1-.232-.272.736.736,0,0,1-.1-.269c-.014-.089-.013-.175-.02-.263-.022-.351-.036-.7-.047-1.043-.023-.69-.03-1.37-.029-2.044s.01-1.344.029-2.009.045-1.326.074-1.984l.093-1.966c.035-.653.079-1.3.119-1.949l.245-3.858c.146-2.556.315-5.077.375-7.542.03-1.23.041-2.447.011-3.63s-.093-2.338-.216-3.414c-.061-.538-.137-1.056-.229-1.539-.046-.242-.1-.474-.151-.7l-.084-.322-.045-.151-.022-.075a.328.328,0,0,0-.023-.067l-.052-.1-.025-.049c0-.006-.009-.02-.015-.034l-.017-.041-.136-.336-.152-.383c-.049-.127-.109-.269-.165-.4-.228-.54-.466-1.113-.724-1.678-.5-1.141-1.062-2.293-1.623-3.447l-1.686-3.473c-.548-1.165-1.081-2.336-1.563-3.521s-.926-2.383-1.305-3.6c-.4-1.211-.724-2.443-1.034-3.68a2.684,2.684,0,0,1,.266-2.062,6.05,6.05,0,0,1,.879-1.243c.1-.112.213-.226.32-.339l.182-.176.091-.088.1-.091a9.251,9.251,0,0,1,.954-.767l6.252-4.375a2.5,2.5,0,0,1,3.476.614,2.537,2.537,0,0,1,.386.865",
								transform: "translate(-367.236 -550.861)",
								fill: "#7284fa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39524",
								"data-name": "Path 39524",
								d: "M337.749,543.348c-4.184,3.956-1.864,18.18-1.864,18.18H349.74s6.87-8.481,5.89-12.942-17.881-5.238-17.881-5.238",
								transform: "translate(-297.841 -482.728)",
								fill: "#76a6f5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39525",
								"data-name": "Path 39525",
								d: "M294.452,564.708a20.093,20.093,0,0,1,1.11,2.165c.32.72.6,1.442.851,2.165s.478,1.446.673,2.171c.1.362.189.725.276,1.088s.157.726.214,1.089.1.727.131,1.091.048.728.054,1.093.01.729.013,1.094.008.729,0,1.094l-.006.547c0,.182-.013.365-.019.548-.011.365-.04.731-.065,1.1-.058.731-.146,1.462-.23,2.193l-.243,2.2-.222,2.2q-.227,2.2-.493,4.426c-.177,1.482-.371,2.974-.6,4.495-.053.376-.116.765-.177,1.148s-.127.777-.194,1.168-.145.8-.22,1.2l-.058.306-.066.318-.133.635c-.2.841-.41,1.625-.633,2.388s-.456,1.5-.693,2.225c-.476,1.451-.973,2.857-1.479,4.247s-1.027,2.759-1.549,4.12-1.047,2.712-1.581,4.055l-1.582,4.017c-.53,1.333-1.051,2.662-1.553,3.989s-1,2.646-1.445,3.955c-.224.654-.433,1.3-.621,1.941-.092.317-.181.634-.258.938-.02.078-.038.152-.056.227s-.037.151-.052.223-.066.144-.226.207a2.034,2.034,0,0,1-.306.093c-.142.031-.279.062-.512.093l-.436.058a6.547,6.547,0,0,1-2.49-.159,2.8,2.8,0,0,1-.48-.175,1.266,1.266,0,0,1-.279-.175.368.368,0,0,1-.169-.33c0-.107.007-.208.01-.312s.008-.207.015-.307c.021-.407.055-.8.091-1.188.076-.775.172-1.529.279-2.273.218-1.487.464-2.943.754-4.382s.584-2.866.89-4.286.639-2.828.961-4.234l.976-4.2c.324-1.395.642-2.785.943-4.17s.589-2.763.843-4.123.475-2.709.6-3.956l.041-.466c.014-.154.029-.308.038-.474.018-.327.041-.647.052-.987s.029-.668.036-1.012.02-.681.023-1.028c.02-1.379.027-2.781,0-4.19s-.071-2.824-.125-4.244l-.086-2.131q-.024-.533-.069-1.067l-.058-.534c-.018-.178-.039-.356-.067-.534l-.078-.534-.093-.534c-.061-.356-.132-.712-.2-1.068s-.137-.712-.2-1.068-.122-.712-.177-1.068-.109-.712-.176-1.068-.142-.711-.225-1.067a18.236,18.236,0,0,1-.4-2.134,10.147,10.147,0,0,1,.009-2.138c.058-.714.155-1.428.283-2.143a19.675,19.675,0,0,1,.5-2.148c.109-.359.223-.717.36-1.076a9.41,9.41,0,0,1,.471-1.072,5.488,5.488,0,0,1,9.543-.3Z",
								transform: "translate(-247.563 -501.345)",
								fill: "#7284fa"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39526",
								"data-name": "Path 39526",
								d: "M306.9,619.869l-.674,2.674s11.213,3.089,14.247,2.866,1.722-8.871,1.722-8.871Z",
								transform: "translate(-272.063 -547.753)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39527",
								"data-name": "Path 39527",
								d: "M454.6,614.33c.149,3.181,2.012,8.351,4.8,8.8s4.944-2.231,4.907-2.38-1.339-6.694-1.339-6.694Z",
								transform: "translate(-403.882 -545.545)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39528",
								"data-name": "Path 39528",
								d: "M332.052,302.122H306.9a9.419,9.419,0,0,1-.366-3.462c.3-4.736,1.383-13.034,1.324-16.437-.086-4.935-1.632-19.3-1.632-19.3s4.716-3.089,6.513-3.546c2.709-.69,8.7-.479,11.491-.365a13.515,13.515,0,0,1,3.986,1.086l5.262,1.815s.838,24.971,0,33.238c-.179,1.77-1.428,6.973-1.428,6.973",
								transform: "translate(-272.063 -230.005)",
								fill: "#cbe9ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39529",
								"data-name": "Path 39529",
								d: "M50.065,65.3a10.589,10.589,0,0,1-1.491-.093q-.722-.1-1.423-.247a20.778,20.778,0,0,1-2.731-.8c-.891-.322-1.751-.723-2.616-1.117s-1.729-.8-2.59-1.213c-1.723-.841-3.438-1.709-5.174-2.73-.435-.257-.875-.521-1.32-.812s-.9-.6-1.384-.976l-.184-.144-.191-.157-.1-.079-.1-.088c-.069-.061-.132-.114-.2-.182l-.216-.2c-.077-.076-.157-.16-.234-.242-.036-.037-.082-.09-.126-.14l-.129-.152-.065-.08-.074-.1q-.074-.1-.144-.2l-.75-1.172-3.053-4.652c-1.022-1.579-2.038-3.184-3.006-4.843a48.583,48.583,0,0,1-2.69-5.217,20.906,20.906,0,0,1-1.033-2.941,11.7,11.7,0,0,1-.306-1.679,8.109,8.109,0,0,1-.038-.938,6.1,6.1,0,0,1,.116-1.027,1.777,1.777,0,0,1,3.511.195l.028.318a3.6,3.6,0,0,0,.054.365c.025.137.066.291.111.448a8.586,8.586,0,0,0,.394,1.02c.16.355.345.717.547,1.08s.416.729.643,1.093c.455.729.947,1.457,1.465,2.179s1.055,1.441,1.6,2.158c1.1,1.433,2.25,2.856,3.417,4.285s2.349,2.866,3.527,4.365l.862,1.105a.626.626,0,0,0-.038-.06l-.021-.028a.056.056,0,0,1-.008-.014.188.188,0,0,0-.013-.022c0-.007-.013-.015-.006-.013a.024.024,0,0,1,.016,0l.045.027c.079.049.187.121.326.2.269.162.612.347.966.527s.732.366,1.118.545c.772.363,1.585.708,2.4,1.056s1.655.684,2.5,1.015,1.686.666,2.538.989,1.712.631,2.546,1A23.576,23.576,0,0,1,49.8,58.171q.6.354,1.18.758a9.875,9.875,0,0,1,1.119.894l.086.082a3.133,3.133,0,0,1-2.118,5.4",
								transform: "translate(-16.607 -28.123)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39530",
								"data-name": "Path 39530",
								d: "M401.645,243.419c-3.31-.539-5.445-.044-5.709.842s.8,2.678.8,2.678h3.849l1.52-.341.3-2.826Z",
								transform: "translate(-351.724 -216.063)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39531",
								"data-name": "Path 39531",
								d: "M411.438,216.358c.013,1.761.077,3.531.171,5.3a2.241,2.241,0,1,1-4.461-.171l0-.017c.246-1.809.523-3.613.852-5.416a1.732,1.732,0,0,1,3.436.3Z",
								transform: "translate(-361.707 -190.685)",
								fill: "#e3b49a"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39532",
								"data-name": "Path 39532",
								d: "M408.3,148.315c0,2.978-1.976,5.392-4.256,5.392s-3.191-2.414-3.191-5.392,1.56-5.392,3.84-5.392,3.607,2.414,3.607,5.392",
								transform: "translate(-356.133 -126.978)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39533",
								"data-name": "Path 39533",
								d: "M123.526,194.244l-3.124-2.988c-2.94,2.313-3.981,4.411-4.8,8.032l3.961,2.356Z",
								transform: "translate(-102.707 -169.918)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39534",
								"data-name": "Path 39534",
								d: "M615.023,182.723l1.339-2.783a9.382,9.382,0,0,1,7.784,2.783l-1.847,2.109Z",
								transform: "translate(-546.406 -159.852)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39535",
								"data-name": "Path 39535",
								d: "M142.28,205.28c-1.84,2.234-4.444,7.553-4.028,9.174.391,1.525.6.753,1.045,1.243.411.454,1.052-.6,1.541-.133.385.365.1,1.963.334,2.377a2.021,2.021,0,0,0,2.733.53c.427-.3.616-1.445,2.066-.627s10.051,8.772,13.513,7.573,1.829-10.825-.4-12.411-10.871-4.288-11.384-5.113c-.377-.607-.061-1.048-.661-1.7-.428-.465-1.264.028-1.636-.2-.2-.123-.037-1.153-.6-1.413a1.825,1.825,0,0,0-2.53.7",
								transform: "translate(-122.788 -181.984)",
								fill: "#cbe9ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39536",
								"data-name": "Path 39536",
								d: "M504.963,206.251c3.493-2.913,10.076-6.842,10.076-7.311a2.14,2.14,0,0,1,1.04-2.208c1.116-.5,7.746.945,9.508,4.239a1.151,1.151,0,0,1-.582,1.641c-.253.1-1.034-.219-1.264-.037-.3.24-.312,1.1-.621,1.31-.613.421-1.183.764-1.5.94-1,.558-10.152,15.649-12.607,13.752s-4.051-12.326-4.051-12.326",
								transform: "translate(-448.626 -174.699)",
								fill: "#cbe9ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39537",
								"data-name": "Path 39537",
								d: "M403.412,265.787c0,1.4-1.6,2.535-3.57,2.535s-3.57-1.135-3.57-2.535,1.6-2.535,3.57-2.535,3.57,1.135,3.57,2.535",
								transform: "translate(-352.061 -233.882)",
								fill: "#e3b49a"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39538",
								"data-name": "Path 39538",
								d: "M391.633,252.749s-1.311,3.645,0,4.883a5.243,5.243,0,0,0,3.015,1.329l.555-2.053s-2.09-1.864-2.309-1.933a13.894,13.894,0,0,1-1.261-2.226",
								transform: "translate(-347.422 -224.551)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39539",
								"data-name": "Path 39539",
								d: "M442.772,256.436v2.272a3.352,3.352,0,0,0,1.88-1.744c.372-1.184-.616-4.216-.616-4.216h-.8a7.679,7.679,0,0,1,.516,2.338,2.333,2.333,0,0,1-.982,1.35",
								transform: "translate(-393.373 -224.55)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39540",
								"data-name": "Path 39540",
								d: "M396.643,186.038c.061.574.052,2.709.51,3.3a5.514,5.514,0,0,0,4.814.662c1.871-.768,1.555-3.178,1.819-3.756s.768.093.667,1.363-.056,4.685-1.969,5.452-5.32.372-6.072-1.226a10.975,10.975,0,0,1-.3-5.8c.316-1.3.5-.325.53,0",
								transform: "translate(-351.697 -164.701)",
								fill: "#7a020c"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39541",
								"data-name": "Path 39541",
								d: "M391.179,127.709c-.986-2.382-.4-4.072,1.494-3.849a5,5,0,0,1,2.634.893s.8-1.187,2.476-.186a1.44,1.44,0,0,1,.617,1.469s1.943-.626,1.8,1.395c-.077,1.08-.837,1.335-2.231.946s-2.393-1.442-4.3-.835-2.105,1.1-2.492.167",
								transform: "translate(-347.117 -110.024)",
								fill: "#7a020c"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39542",
								"data-name": "Path 39542",
								d: "M.011,27.387c-.2.809,2.091,2.789,3.146,3.347s3.034-1.311,3.146-3.18-.378-4.518-1.55-4.518A6.585,6.585,0,0,0,1.629,24.1,3.6,3.6,0,0,0,.011,27.387",
								transform: "translate(0 -20.466)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39543",
								"data-name": "Path 39543",
								d: "M497.861,1232.433c-.68-.684-1.064-.694-2.226-1.063-1.294-.411-3.078-1.219-3.372-2.633l-4.365.138a3.384,3.384,0,0,0-.022.62c-.028,1.713-.55,2.857-.431,3.961,3.329.266,9.421-.006,10.58.092a1.352,1.352,0,0,0-.164-1.115",
								transform: "translate(-433.047 -1093.674)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39544",
								"data-name": "Path 39544",
								d: "M282.9,1233.049a5,5,0,0,0-2.2-1.114,3.62,3.62,0,0,1-2.269-2.549l-4.573.145s-.026-.4-.119.6c-.105,1.13-.7,2.8-.586,3.906,3.33.265,8.86-.006,10.019.092.052-.432.192-.5-.275-1.076",
								transform: "translate(-242.666 -1094.25)",
								fill: "#00406b"
							})
						]
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_14234",
					"data-name": "Group 14234",
					transform: "translate(7128.888 3579.149)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_14233",
						"data-name": "Group 14233",
						transform: "translate(0 0)",
						clipPath: "url(#clip-path-no-high-risk-3)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39568",
								"data-name": "Path 39568",
								d: "M279.808,1154a3.824,3.824,0,0,0,.127,1.331l-.887,1.562-3.413.543v-1.557l.417-.276,1.734-.688Z",
								transform: "translate(-242.835 -1023.739)",
								fill: "#ffa88d"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39569",
								"data-name": "Path 39569",
								d: "M189.58,1103.836a5.1,5.1,0,0,0,1.222,1.2c.045.036-.344,3.183-.344,3.183l-1.865,1.859-.742-2.3.172-1.476Z",
								transform: "translate(-144.168 -979.023)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39570",
								"data-name": "Path 39570",
								d: "M549.39,1.8a23.406,23.406,0,0,0,.308,4.125c.048.335.116.66.174.992s.131.654.208.975c.145.648.316,1.283.5,1.916.092.317.191.631.3.949.053.16.107.316.169.488l.17.453.633,1.69,1.267,3.38a1.771,1.771,0,0,0,2.525,1.145,2.6,2.6,0,0,0,.929-3.114c-.017-.046-.038-.1-.058-.141l-1.448-3.267-.724-1.634-.168-.378c-.047-.108-.1-.234-.147-.357-.1-.249-.2-.506-.289-.766-.185-.521-.361-1.051-.513-1.589-.081-.268-.147-.539-.221-.808s-.136-.542-.19-.814A18.687,18.687,0,0,1,552.38,1.8V1.767a1.659,1.659,0,0,0-1.56-1.761,1.713,1.713,0,0,0-1.429,1.8",
								transform: "translate(-549.386 1.457)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39571",
								"data-name": "Path 39571",
								d: "M32.689,482.1a4.5,4.5,0,0,1-.689-.3,6.928,6.928,0,0,1-.714-.465c-.236-.178-.469-.372-.692-.578-.112-.1-.222-.209-.326-.317-.053-.054-.1-.107-.153-.161l-.07-.078c-.012-.014-.021-.024-.03-.036L30,480.14c0-.005,0,0,0-.006a2.013,2.013,0,1,0-3.174,2.286l.546.462.048.041.036.029.071.055.134.1c.088.065.176.128.264.189.176.122.353.238.533.35a12.527,12.527,0,0,0,1.123.618,10,10,0,0,0,1.237.494,7.225,7.225,0,0,0,1.4.29,1.492,1.492,0,0,0,.642-2.894Z",
								transform: "translate(30.343 -421.962)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39572",
								"data-name": "Path 39572",
								d: "M188.746,1073.9a16.54,16.54,0,0,1,1.888,1.706,11.763,11.763,0,0,1,.8.936,5.874,5.874,0,0,1,.574.891l.06.12a1.493,1.493,0,0,0,2.765-1.1,8.348,8.348,0,0,0-.7-1.621,14.85,14.85,0,0,0-.85-1.352,20.077,20.077,0,0,0-1.984-2.4l-.016-.017a1.907,1.907,0,1,0-2.744,2.65,2.069,2.069,0,0,0,.208.186",
								transform: "translate(-148.279 -949.295)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39573",
								"data-name": "Path 39573",
								d: "M271.967,242.187c0,3.885,2.688,10.9,5.6,10.9s6.53-7.015,6.53-10.9-4.033-4.016-5.434-4.02c-2.388-.007-6.7.135-6.7,4.02",
								transform: "translate(-246.601 -207.403)",
								fill: "#e3b49a"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39574",
								"data-name": "Path 39574",
								d: "M272.276,1109.779l.113,5.128a1.78,1.78,0,0,0,3.543.2l.683-5.084a2.179,2.179,0,0,0-4.32-.58,2.353,2.353,0,0,0-.019.338",
								transform: "translate(-239.17 -982.335)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39575",
								"data-name": "Path 39575",
								d: "M62.362,261.544l-.068.116c-.025.037-.047.073-.068.108-.042.07-.087.143-.124.21l-.115.2-.1.2c-.072.133-.127.257-.186.384s-.11.25-.16.371a8.081,8.081,0,0,0-.437,1.384A6.488,6.488,0,0,0,61,266.9a5.157,5.157,0,0,0,.257,1.026,5.336,5.336,0,0,0,.432.928c.339.59.668,1.186,1.027,1.765s.714,1.161,1.1,1.723c.19.283.382.566.578.847s.4.555.606.83c.4.557.843,1.087,1.27,1.627.222.264.45.526.675.789.114.131.224.263.34.392l.354.384c.932,1.03,1.941,2.01,2.989,2.959s2.155,1.851,3.285,2.734c.563.44,1.153.866,1.733,1.288.6.416,1.188.829,1.8,1.229l.456.3.47.291c.315.192.618.387.947.568l.483.274c.081.045.159.093.245.131a.962.962,0,0,0,.292.075,1.883,1.883,0,0,0,.766-.09,3.858,3.858,0,0,0,1.069-.537,5.211,5.211,0,0,0,1.941-2.461l.129-.339a5.664,5.664,0,0,0,.331-1.167,1.614,1.614,0,0,0-.007-.674.7.7,0,0,0-.1-.212,1.405,1.405,0,0,0-.145-.157l-.3-.3c-.2-.194-.4-.414-.593-.623l-.294-.316-.288-.331c-.384-.437-.766-.89-1.151-1.336-.376-.463-.756-.919-1.121-1.4-.381-.461-.749-.945-1.119-1.422l-.547-.731c-.189-.237-.369-.487-.554-.729-.372-.484-.724-.99-1.092-1.481s-.73-.993-1.086-1.5l-1.075-1.519-.531-.768-.526-.773q-1.052-1.549-2.06-3.138-.5-.794-1-1.6c-.33-.534-.663-1.066-1.03-1.579s-.748-1.019-1.163-1.507c-.206-.244-.421-.484-.646-.718-.11-.118-.23-.23-.346-.344-.057-.057-.117-.112-.179-.167l-.091-.08-.047-.039-.044-.032a2.814,2.814,0,0,0-3.931.62q-.08.11-.148.225Z",
								transform: "translate(-24.183 -225.482)",
								fill: "#f4dbd7"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39576",
								"data-name": "Path 39576",
								d: "M397.411,113.949a3.356,3.356,0,0,0-.172-.375,3.144,3.144,0,0,0-.2-.316c-.018-.024-.034-.048-.052-.071l-.059-.073a1.832,1.832,0,0,0-.12-.139,1.74,1.74,0,0,0-.122-.127c-.043-.041-.087-.09-.132-.13l-.136-.12c-.046-.041-.093-.07-.142-.111-.1-.083-.2-.148-.3-.22l-.322-.2c-.111-.066-.221-.127-.332-.2a30.443,30.443,0,0,1-2.691-1.882c-.446-.345-.888-.7-1.326-1.073-.221-.181-.436-.373-.654-.56s-.437-.375-.655-.565-.433-.383-.648-.578l-.322-.292-.318-.3c-.427-.394-.852-.792-1.271-1.2-.834-.815-1.668-1.637-2.47-2.489-.2-.211-.4-.428-.6-.64l-.3-.32-.3-.324c-.4-.43-.782-.872-1.168-1.312-.778-.877-1.515-1.785-2.234-2.705l-.271-.345-.263-.349c-.174-.234-.354-.465-.52-.7s-.342-.472-.506-.711l-.122-.18-.061-.09a.235.235,0,0,0-.077-.081.617.617,0,0,0-.359-.047,2.072,2.072,0,0,0-.312.049c-.063.014-.121.025-.2.047-.038.011-.069.017-.114.032l-.129.04-.2.061a7.675,7.675,0,0,0-2.849,1.627l-.1.088c-.034.03-.055.053-.083.08-.057.055-.095.1-.137.146a1.856,1.856,0,0,0-.194.249.678.678,0,0,0-.137.359.34.34,0,0,0,.029.125l.043.118.086.236c.115.314.24.621.36.933s.251.618.378.927l.194.463.2.458c.537,1.223,1.1,2.445,1.708,3.638a53.09,53.09,0,0,0,4.161,6.933,35.9,35.9,0,0,0,5.537,6.1l.4.349c.132.117.278.226.417.339l.422.336.436.333c.147.111.289.222.441.331l.461.32.231.159.241.158.483.315c.164.1.337.208.505.312a2.649,2.649,0,0,0,.545.266,3.073,3.073,0,0,0,.623.151,3.592,3.592,0,0,0,.71.024c.06,0,.124-.01.186-.017s.122-.013.191-.025c.134-.019.271-.049.408-.081l.208-.057.21-.069c.071-.024.14-.053.213-.08s.152-.062.227-.094.152-.07.228-.108l.23-.126c.076-.042.151-.084.229-.137l.234-.152c.083-.058.165-.118.246-.177s.164-.131.244-.2c.04-.032.081-.071.122-.111l.122-.118.12-.119c.04-.042.082-.091.122-.136l.678-.762a4.594,4.594,0,0,0,.846-4.722",
								transform: "translate(-371.282 -79.904)",
								fill: "#f4dbd7"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39577",
								"data-name": "Path 39577",
								d: "M224.955,556.628a10.027,10.027,0,0,0-.521,1.786,17.422,17.422,0,0,0-.268,1.793c-.056.6-.085,1.2-.092,1.8,0,.3,0,.6.009.9l.027.9.22,7.207c.165,4.805.343,9.611.576,14.418.059,1.2.108,2.4.176,3.605l.2,3.606.4,7.212.442,7.213.222,3.607.111,1.8.055.9.028.451a.235.235,0,0,0,.024.113.376.376,0,0,0,.114.116l.045.029.053.03c.038.02.088.04.132.06a2.657,2.657,0,0,0,.394.123l.033.008a8.586,8.586,0,0,0,3.422.086,2.53,2.53,0,0,0,.392-.1c.044-.018.094-.035.132-.053l.054-.027.045-.027a.366.366,0,0,0,.117-.109.236.236,0,0,0,.027-.112l.042-.449.085-.9.169-1.8.338-3.591.637-7.184.585-7.185.293-3.593.279-3.593q.552-7.186,1.119-14.372l.572-7.185.589-7.185a5.4,5.4,0,0,0-10.367-2.511Z",
								transform: "translate(-193.549 -486.334)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39578",
								"data-name": "Path 39578",
								d: "M227.125,552.139c-.33,2.6-.645,5.177-.955,7.768s-.609,5.177-.9,7.771-.567,5.192-.822,7.8q-.192,1.959-.361,3.933c-.111,1.32-.213,2.643-.289,4.011-.037.688-.068,1.378-.076,2.14,0,.191,0,.391,0,.6s.01.437.028.709l.017.218.012.125.015.132c.013.1.024.192.048.329.011.064.02.118.04.21l.028.124c.009.039.022.094.025.1.079.265.161.539.253.774a12.9,12.9,0,0,0,1.237,2.432c.441.7.9,1.312,1.363,1.9a40.712,40.712,0,0,0,2.853,3.205c.97.994,1.96,1.93,2.961,2.84s2.022,1.779,3.053,2.627c.513.427,1.039.836,1.564,1.244s1.053.811,1.584,1.21,1.076.777,1.617,1.16l.813.571c.271.19.543.379.82.56q.828.549,1.664,1.088l.839.537.423.267a.2.2,0,0,0,.12.049.477.477,0,0,0,.213-.074,2.531,2.531,0,0,0,.34-.242c.032-.026.072-.061.111-.1l.117-.1.136-.128.156-.155a7.9,7.9,0,0,0,1.3-1.7l.1-.18.108-.192.088-.164.069-.141c.023-.047.046-.094.063-.132a2.732,2.732,0,0,0,.146-.389.485.485,0,0,0,.019-.221c-.01-.052-.046-.07-.074-.1l-.349-.324-.7-.656-1.4-1.313c-.231-.222-.466-.437-.7-.653l-.7-.652q-.7-.654-1.386-1.315t-1.389-1.3l-1.37-1.311q-1.367-1.308-2.672-2.648c-.868-.891-1.7-1.8-2.485-2.727-.2-.231-.389-.461-.576-.694s-.365-.47-.541-.705c-.351-.47-.683-.941-.984-1.406-.073-.116-.149-.232-.219-.347s-.136-.233-.2-.348c-.124-.23-.243-.456-.341-.673a4.486,4.486,0,0,1-.383-1.1,1.045,1.045,0,0,1-.015-.161.291.291,0,0,1,.012.04l.016.065.02.09c.011.057.014.066.019.088s0,.007,0,.011,0,.006,0,0a.148.148,0,0,0,.005-.025c.006-.052.013-.151.023-.263l.036-.37c.053-.532.14-1.134.234-1.735.047-.3.1-.608.148-.915l.169-.925q.174-.929.36-1.867l.189-.938.2-.939.418-1.881c.283-1.255.585-2.51.884-3.766l.9-3.771.438-1.889c.145-.63.3-1.259.435-1.89q.424-1.892.816-3.79c.263-1.265.511-2.532.753-3.8a7.334,7.334,0,0,0,.079-1.946,6.767,6.767,0,0,0-.182-1.007,4.459,4.459,0,0,0-.406-1.039l-1.828-3.237a4.416,4.416,0,0,0-8.225,1.615",
								transform: "translate(-205.34 -483.823)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39579",
								"data-name": "Path 39579",
								d: "M136.7,91.658c1.634-2.759,6.559-6.409,10.322-1.768,2.278,2.809.278,4.942,1.59,5.356s4.705,4.078,1.393,6.192-9.007,3.33-10.864-1.391a17.605,17.605,0,0,1-.9-5.846c-.016-.441-1.208-.755-1.2-1.125.026-1.122-.344-1.418-.344-1.418",
								transform: "translate(-99.217 -73.257)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39580",
								"data-name": "Path 39580",
								d: "M297.908,185.178c.014.385.014.765-.006,1.14s-.057.745-.11,1.123-.123.768-.2,1.2-.155.9-.208,1.436l-.011.111a2.465,2.465,0,1,0,4.906.489,2.591,2.591,0,0,0-.007-.548c-.042-.34-.063-.738-.079-1.181s-.032-.925-.069-1.42-.094-1-.177-1.5-.188-.985-.311-1.462a1.9,1.9,0,0,0-3.732.542Z",
								transform: "translate(-267.552 -158.358)",
								fill: "#e3b49a"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39581",
								"data-name": "Path 39581",
								d: "M268.718,110.116c0,3.112,2.655,4.64,5.767,4.64.948,0,1.822.5,2.849-1.37.707-1.29,2.231-3.85,2.231-5.12,0-3.112-2.806-3.776-5.212-3.785-4.312-.015-5.635,2.523-5.635,5.635",
								transform: "translate(-241.713 -88.242)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39582",
								"data-name": "Path 39582",
								d: "M288.181,121.974c0,2.9,1.067,6.285,2.407,6.285,2.211,0,5.644-1.959,5.644-4.858s-1.7-6.072-3.92-6.072-4.131,1.747-4.131,4.645",
								transform: "translate(-260.495 -99.693)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39583",
								"data-name": "Path 39583",
								d: "M281.451,103.034c-1.267-2.691-3.251-.81-4.787-.427a2.3,2.3,0,0,1-2.622-1.639c-.412-1.358,1.611-2.289,2.624-2.433s3.6-1.008,6.19,1.186-1.4,3.313-1.4,3.313",
								transform: "translate(-246.452 -82.684)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39584",
								"data-name": "Path 39584",
								d: "M234.873,248.889a9.7,9.7,0,0,0-7.006-2.908s-4.758,8.492-6.822,12.838-2.018,10.647-2.018,10.647h11.416l1.923-4.3a25.545,25.545,0,0,0,2.2-9.31Z",
								transform: "translate(-191.623 -214.366)",
								fill: "#f3e2db"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39585",
								"data-name": "Path 39585",
								d: "M330.229,243.59c-.915,2.693,4.6,16.817,4.6,16.817l-.576,6.845h-6.885s-4.677-5.2-4.786-9.959,2.9-12.879,3.332-13.136a7.5,7.5,0,0,1,4.32-.566",
								transform: "translate(-302.825 -212.151)",
								fill: "#f3e2db"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39586",
								"data-name": "Path 39586",
								d: "M193.6,489.077c.879-1.791,4.291-6.728,4.291-6.728l14.287-.915c3.14,4.358,4.783,8.049,7.333,16.05a2.2,2.2,0,0,1,.056.5s0,.015,0,.015a1.6,1.6,0,0,1-.168.71l-8.145,32.451-5.187-28.573s-6.074,15.4-6.4,15.722l-7.86,8.505-1.03-29.883s1.9-5.984,2.823-7.858",
								transform: "translate(-173.245 -424.241)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39587",
								"data-name": "Path 39587",
								d: "M258.8,465.493l14.287-.478v-2.846H258.8Z",
								transform: "translate(-234.159 -407.069)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39588",
								"data-name": "Path 39588",
								d: "M280.974,121.014c1.935,1.177.941,4.184,1.222,4.3.955-.828.82,1.111.82,1.111s-.106,1.108-.912,1.024a3.334,3.334,0,0,1-.189,1.32,4.07,4.07,0,0,0,1.267-.936c1.29-1.948.362-5.525.362-5.525l-1.826-2.107Z",
								transform: "translate(-247.347 -102.251)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39589",
								"data-name": "Path 39589",
								d: "M315.983,465.325h1.277a.939.939,0,0,0,.939-.939v-1.277a.939.939,0,0,0-.939-.939h-1.277a.939.939,0,0,0-.939.939v1.277a.939.939,0,0,0,.939.939",
								transform: "translate(-285.382 -407.069)",
								fill: "#ffa608"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39590",
								"data-name": "Path 39590",
								d: "M3.868,509.876c4.225,1.63,4.117,5.106,3.193,6.138s-2.444-.435-2.716-.923-1.3-2.085-2.39-1.8S.057,511.925,0,510.955s3.867-1.079,3.867-1.079",
								transform: "translate(59.463 -449.593)",
								fill: "#efbfa5"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39591",
								"data-name": "Path 39591",
								d: "M173.729,1110.794a5.218,5.218,0,0,0,1.376.729c.481.2,1.489,1.6.7,2.637a4.659,4.659,0,0,0-1.19,3.431c.014,1.7-3.006,3.285-3.2,3.131-.77-.625-.275-1.9-.136-3.078.066-.817-.205-2.39-.211-3.477.1-1.05.32-.833.32-.833a7.65,7.65,0,0,0,.652,2.01,18.168,18.168,0,0,1,1.888-3.015c.34-.57-.2-1.535-.2-1.535",
								transform: "translate(-127.63 -985.225)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39592",
								"data-name": "Path 39592",
								d: "M162.251,1131.958l-1.415-2.062-1.432,1.218,1.809,1.727Z",
								transform: "translate(-112.523 -1002.251)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39593",
								"data-name": "Path 39593",
								d: "M278.948,1196.523l.324-2.48-1.879-.049.193,2.494Z",
								transform: "translate(-242.363 -1059.385)",
								fill: "#00406b"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_39594",
								"data-name": "Path 39594",
								d: "M281.12,1164.842c.1.334.176,1.022.323,1.656a1.51,1.51,0,0,1-1.12,1.979c-1.278.227-1.3,1.01-2.766,1.87a11.809,11.809,0,0,1-5.012.3c-.144-.981,1.083-1.585,1.983-2.359.6-.556,1.466-1.9,2.2-2.7a.7.7,0,0,1,.552-.314,8.219,8.219,0,0,0-.271,1.512,17.868,17.868,0,0,1,3.168-.815c.987-.371.946-1.122.946-1.122",
								transform: "translate(-244.061 -1033.401)",
								fill: "#00406b"
							})
						]
					})
				})]
			})]
		})
	})]
});
export default SvgNoRiskyEntities;
